import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { JSONTag, Tag } from 'models/tag';
import TagsManagerBase from './base';

export interface ReadOnlyCollectionTagsManagerConfig {
    tags?: SubscribableOrNullableValue<Array<Tag>>
    add?: (tag: JSONTag) => void | Promise<void>
    remove?: (tag: Tag) => void | Promise<void>
}

export default class ReadOnlyCollectionTagsManager extends TagsManagerBase {
    private tagsCollection: Subscribable<Array<Tag>>

    private addHandler?: (tag: JSONTag) => void | Promise<void>
    private removeHandler?: (tag: Tag) => void | Promise<void>

    constructor(jsonManager: ReadOnlyCollectionTagsManagerConfig) {
        super();

        this.tagsCollection = ko.flattenComputed(jsonManager.tags, []);

        this.addHandler = jsonManager.add;
        this.removeHandler = jsonManager.remove;

        this.effects.register([
            this.tagsCollection.subscribe(this.update, this)
        ]);
    }

    addTag(jsonTag: JSONTag): Promise<void> {
        if (this.addHandler)
            return Promise.resolve(this.addHandler(jsonTag));
        else
            return Promise.reject(new Error('no add handler is provided'))
    }

    removeTag(tag: Tag) {
        if (this.removeHandler)
            return this.source.find(tag.contentTagId()).then(this.removeHandler, _.noop);
        else
            return Promise.reject(new Error('no remove handler is provided'))
    }

    protected load(): Array<any> {
        return _.clone(this.tagsCollection());
    }

    protected override map(tag: any) {
        return tag;
    }

    protected override isRemoveAllowed() {
        return this.removeHandler != undefined;
    }
}